import { compareAsc, parse } from 'date-fns';
import { FLIGHT_DATETIME_FORMAT } from '../../services/constants';
const sortByDepartureDateTime = (flightA, flightB) => {
    const flightADeparture = parse(`${flightA.departure.date} ${flightA.departure.time}`, FLIGHT_DATETIME_FORMAT, new Date());
    const flightBDeparture = parse(`${flightB.departure.date} ${flightB.departure.time}`, FLIGHT_DATETIME_FORMAT, new Date());
    return compareAsc(flightADeparture, flightBDeparture);
};
const filterBySelectedAirport = (flight, selectedAirport) => {
    return (flight.departure.airport.iata === selectedAirport.iata || flight.arrival.airport.iata === selectedAirport.iata);
};
const escapeSpecialSymbols = (value) => {
    const specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}'];
    let newValue = value;
    for (const specialSymbol of specials) {
        const specialSymbolPos = value.indexOf(specialSymbol);
        if (specialSymbolPos !== -1) {
            // tslint:disable-next-line:prefer-template
            newValue = newValue.substring(0, specialSymbolPos) + '\\' + newValue.substring(specialSymbolPos);
        }
    }
    return newValue;
};
const filterByInput = (flight, value) => {
    const regex = new RegExp(escapeSpecialSymbols(value), 'i');
    const valuesToCompare = [
        flight.departure.airport.iata,
        flight.arrival.airport.iata,
        flight.departure.airport.name,
        flight.arrival.airport.name,
        flight.departure.airport.city.name,
        flight.arrival.airport.city.name
    ];
    const flightNumber = `${flight.airline.iata}-${flight.flightNumber}`;
    return valuesToCompare.some(value => !!value.match(regex)) || !!flightNumber.match(regex);
};
const filterByDepartureOrArrival = (flight, filterBy, filterType) => {
    switch (filterType) {
        case 'all':
            return true;
        case 'arrival':
        case 'departure':
            return typeof filterBy === 'string'
                ? flight[filterType].airport.city.name.toLowerCase().includes(filterBy.toLowerCase()) ||
                    flight[filterType].airport.iata.toLowerCase().includes(filterBy.toLowerCase())
                : flight[filterType].airport.city.name === filterBy.city.name;
        default:
            return true;
    }
};
export const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'setState': {
            return Object.assign({}, payload);
        }
        case 'setFlights': {
            return Object.assign(Object.assign({}, state), { flights: [...payload].sort(sortByDepartureDateTime) });
        }
        case 'setInput':
            let flights = state.flights.filter(flight => filterByInput(flight, payload));
            if (state.filterType !== 'all') {
                flights = flights.filter(flight => filterByDepartureOrArrival(flight, state.input, state.filterType));
            }
            return Object.assign(Object.assign({}, state), { input: payload, filteredFlights: flights, drawerOpen: true });
        case 'setCollapseOpen': {
            return Object.assign(Object.assign({}, state), { collapseOpen: payload });
        }
        case 'setFilterType':
            return Object.assign(Object.assign({}, state), { filteredFlights: state.flights.filter(flight => filterByDepartureOrArrival(flight, state.input, payload)), filterType: payload });
        case 'setSelectedFlight':
            if (payload === null) {
                return Object.assign(Object.assign({}, state), { filteredFlights: [] });
            }
            return Object.assign(Object.assign({}, state), { filteredFlights: state.flights.filter(flight => flight.uniqueId === payload.uniqueId) });
        case 'setSelectedAirport':
            if (payload === null) {
                return Object.assign(Object.assign({}, state), { filteredFlights: [], input: '', drawerOpen: true, filterType: 'all' });
            }
            let filteredFlights = state.flights.filter(flight => filterBySelectedAirport(flight, payload));
            if (state.filterType !== 'all') {
                filteredFlights = filteredFlights.filter(flight => filterByDepartureOrArrival(flight, state.input, state.filterType));
            }
            return Object.assign(Object.assign({}, state), { drawerOpen: true, input: payload.iata, filteredFlights: filteredFlights });
        case 'setDrawerOpen': {
            return Object.assign(Object.assign({}, state), { drawerOpen: payload });
        }
        default:
            return state;
    }
};
